import { override, extend } from 'flarum/common/extend';
import highlight from 'flarum/common/helpers/highlight';
import Link from 'flarum/common/components/Link';
import listItems from 'flarum/common/helpers/listItems';
import classList from 'flarum/common/utils/classList';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import app from 'flarum/forum/app';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import TerminalPost from 'flarum/forum/components/TerminalPost';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import tagsLabel from 'flarum/tags/common/helpers/tagsLabel';

import DiscussionExcerpt from './components/DiscussionExcerpt';
import DiscussionVotes from './components/DiscussionVotes';
import DiscussionSubs from './components/DiscussionSubs';
import DiscussionShare from './components/DiscussionShare';

/**
 * NOTE: 临时解决在移动端下controls按钮切换节点导致的问题
 */
const isMobileWidth = window.innerWidth <= 768;

export default function () {
  override(DiscussionListItem.prototype, 'replyCountItem', function () {
    const discussion = this.attrs.discussion;
    const showUnread = !this.showRepliesCount() && discussion.isUnread();

    if (showUnread) {
      return (
        <button className="Button--ua-reset DiscussionListItem-count" onclick={this.markAsRead.bind(this)}>
          <span aria-hidden="true">{abbreviateNumber(discussion.unreadCount())} 条未读</span>

          {/*<span className="visually-hidden">*/}
          {/*  {app.translator.trans('core.forum.discussion_list.unread_replies_a11y_label', { count: discussion.replyCount() })}*/}
          {/*</span>*/}
        </button>
      );
    }

    return (
      <span className="DiscussionListItem-count" onclick={() => (location.href = app.route.discussion(discussion, this.getJumpTo()))}>
        <span aria-hidden="true">{abbreviateNumber(discussion.replyCount())} 条回复</span>

        {/*<span className="visually-hidden">*/}
        {/*  {app.translator.trans('core.forum.discussion_list.total_replies_a11y_label', { count: discussion.replyCount() })}*/}
        {/*</span>*/}
      </span>
    );
  });

  extend(DiscussionListItem.prototype, 'controlsView', function (vnode) {
    vnode.attrs.icon = 'fas fa-ellipsis-h';
  });

  override(DiscussionListItem.prototype, 'mainView', function () {
    const { discussion, params } = this.attrs;
    const jumpTo = this.getJumpTo();
    const items = this.infoItems();

    let excerpt = items.has('excerpt') ? items.get('excerpt') : null;
    let terminalPost = items.has('terminalPost') ? items.get('terminalPost') : null;

    items.remove('excerpt');
    items.remove('terminalPost');
    items.remove('tags');

    if (!excerpt) {
      excerpt = <DiscussionExcerpt discussion={discussion} />;
    }

    if (!terminalPost) {
      terminalPost = <TerminalPost discussion={discussion} lastPost={!this.showFirstPost()} />;
    }

    // 添加点赞数量 fof/gamification
    if (discussion.seeVotes?.()) {
      items.add('votes', <DiscussionVotes discussion={discussion} />, 5);
    }

    // 添加回复数量
    items.add('replyCount', this.replyCountItem());

    // 添加关注
    items.add('subscription', <DiscussionSubs discussion={discussion} />);

    // 添加分享
    items.add('share', <DiscussionShare discussion={discussion} />);

    // 添加编辑按钮
    if (!isMobileWidth) {
      const controls = DiscussionControls.controls(discussion, this).toArray();
      items.add('controls', this.controlsView(controls));
    }

    // tags
    const tags = this.attrs.discussion.tags();

    return (
      <div className="DiscussionListItem-main">
        <div className="DiscussionListItem-header">
          {this.authorAvatarView()}
          {this.badgesView()}
          <Link href={app.route.discussion(discussion)}>
            <h2 className="DiscussionListItem-title">{highlight(discussion.title(), this.highlightRegExp)}</h2>
          </Link>
        </div>
        {excerpt && (
          <ul className="DiscussionListItem-info excerpt" onclick={() => (location.href = app.route.discussion(discussion, jumpTo))}>
            {excerpt}
          </ul>
        )}
        {terminalPost && (
          <ul className="DiscussionListItem-info post">
            <Link href={app.route.discussion(discussion, jumpTo)}>{terminalPost}</Link>
            <li class="item-tags">{tagsLabel(tags, { link: true })}</li>
          </ul>
        )}
        <ul className="DiscussionListItem-info actions">{listItems(items.toArray())}</ul>
      </div>
    );
  });

  override(DiscussionListItem.prototype, 'contentView', function () {
    const discussion = this.attrs.discussion;
    const isUnread = discussion.isUnread();
    const isRead = discussion.isRead();

    return <div className={classList('DiscussionListItem-content', 'Slidable-content', { unread: isUnread, read: isRead })}>{this.mainView()}</div>;
  });

  override(DiscussionListItem.prototype, 'view', function () {
    const discussion = this.attrs.discussion;

    const attrs = this.elementAttrs();

    return (
      <div {...attrs}>
        {isMobileWidth ? this.controlsView(DiscussionControls.controls(discussion, this).toArray()) : null}
        {this.slidableUnderneathView()}
        {this.contentView()}
      </div>
    );
  });
}
